import { render, staticRenderFns } from "./userAwards.vue?vue&type=template&id=fc940af8"
import script from "./userAwards.vue?vue&type=script&lang=js"
export * from "./userAwards.vue?vue&type=script&lang=js"
import style0 from "./userAwards.vue?vue&type=style&index=0&id=fc940af8&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports